import videojs, { VideoJsPlayer } from 'video.js';

export function createSubtitleButton(playerRef: VideoJsPlayer) {
  const Component = videojs.getComponent('SubtitlesButton');
  const subtitleButton = new Component(playerRef);
  playerRef.controlBar.addChild(subtitleButton);
}
